var _style, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgOpen(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "open_svg__Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    x: 0,
    y: 0,
    viewBox: "0 0 17 17",
    xmlSpace: "preserve"
  }, props), _style || (_style = /*#__PURE__*/React.createElement("style", null, ".open_svg__st0{fill:none;stroke:currentColor;stroke-width:1.5;stroke-linecap:round;stroke-linejoin:round}")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "open_svg__Icon_-_Open",
    transform: "rotate(45 6.857 13.33)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "open_svg__Group_1994",
    transform: "rotate(180 7.835 5.739)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "open_svg__Line_716",
    className: "open_svg__st0",
    d: "M11.1 10.4L11-.6"
  })), /*#__PURE__*/React.createElement("path", {
    id: "open_svg__Path_5351",
    className: "open_svg__st0",
    d: "M1.8 3.8l2.7-2.7 2.7 2.7"
  }), /*#__PURE__*/React.createElement("g", {
    id: "open_svg__Group_1996"
  }, /*#__PURE__*/React.createElement("path", {
    id: "open_svg__Path_5352",
    className: "open_svg__st0",
    d: "M10 3.3c3.1 3.1 3.1 7.9 0 10.9s-7.9 3.1-10.8 0-3.1-7.9 0-10.9"
  })))));
}
export default "data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBlbmNvZGluZz0idXRmLTgiPz4KPCEtLSBHZW5lcmF0b3I6IEFkb2JlIElsbHVzdHJhdG9yIDI3LjguMSwgU1ZHIEV4cG9ydCBQbHVnLUluIC4gU1ZHIFZlcnNpb246IDYuMDAgQnVpbGQgMCkgIC0tPgo8c3ZnIHZlcnNpb249IjEuMSIgaWQ9IkxheWVyXzEiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyIgeG1sbnM6eGxpbms9Imh0dHA6Ly93d3cudzMub3JnLzE5OTkveGxpbmsiIHg9IjBweCIgeT0iMHB4IgoJIHZpZXdCb3g9IjAgMCAxNyAxNyIgc3R5bGU9ImVuYWJsZS1iYWNrZ3JvdW5kOm5ldyAwIDAgMTcgMTc7IiB4bWw6c3BhY2U9InByZXNlcnZlIj4KPHN0eWxlIHR5cGU9InRleHQvY3NzIj4KCS5zdDB7ZmlsbDpub25lO3N0cm9rZTpjdXJyZW50Q29sb3I7c3Ryb2tlLXdpZHRoOjEuNTtzdHJva2UtbGluZWNhcDpyb3VuZDtzdHJva2UtbGluZWpvaW46cm91bmQ7fQo8L3N0eWxlPgo8ZyBpZD0iSWNvbl8tX09wZW4iIHRyYW5zZm9ybT0idHJhbnNsYXRlKDExLjQzNCAtMC45NDQpIHJvdGF0ZSg0NSkiPgoJPGcgaWQ9Ikdyb3VwXzE5OTQiIHRyYW5zZm9ybT0idHJhbnNsYXRlKDE1LjY3IDExLjQ3OCkgcm90YXRlKDE4MCkiPgoJCTxsaW5lIGlkPSJMaW5lXzcxNiIgY2xhc3M9InN0MCIgeDE9IjExLjEiIHkxPSIxMC40IiB4Mj0iMTEiIHkyPSItMC42Ii8+Cgk8L2c+Cgk8cGF0aCBpZD0iUGF0aF81MzUxIiBjbGFzcz0ic3QwIiBkPSJNMS44LDMuOGwyLjctMi43bDIuNywyLjciLz4KCTxnIGlkPSJHcm91cF8xOTk2Ij4KCQk8cGF0aCBpZD0iUGF0aF81MzUyIiBjbGFzcz0ic3QwIiBkPSJNMTAsMy4zYzMuMSwzLjEsMy4xLDcuOSwwLDEwLjlzLTcuOSwzLjEtMTAuOCwwcy0zLjEtNy45LDAtMTAuOWwwLDAiLz4KCTwvZz4KPC9nPgo8L3N2Zz4K";
export { SvgOpen as ReactComponent };